module.exports = __webpack_public_path__ + "img/home_bg_dark.5f7e171d.svg";